import { render, staticRenderFns } from "./fullscreenButton.vue?vue&type=template&id=43acef5c&scoped=true&"
import script from "./fullscreenButton.vue?vue&type=script&lang=ts&"
export * from "./fullscreenButton.vue?vue&type=script&lang=ts&"
import style0 from "./fullscreenButton.vue?vue&type=style&index=0&id=43acef5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43acef5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
